angular.module('tgaAdmin')
  .controller('QuestionListsController', ['$scope', '$state', 'questionListService',
    function ($scope, $state, questionListService) {
      $scope.data = {
        alerts: [],
      };

      $scope.viewmodel = {
        questionLists: [],
      };

      $scope.initialize = function () {
        $scope.loading = true;

        questionListService.getQuestionLists().then((questionLists) => {
          $scope.viewmodel.questionLists = questionLists;
          $scope.loading = false;
        }).catch((error) => {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
            'danger',
          );
        });
      };

      $scope.actions = {
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
